import React, { useEffect, useRef, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import RoundedProfilePicture from '../../../../components/profile-picture/rounded-profile-picture.comonent';
import { Recco } from '../../../../models';

const ReccoCard = ({ recco }: { recco: Recco }) => {
  const messageRef = useRef<HTMLDivElement>(null);
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const toggleDescription = () => setIsExpanded(prev => !prev);

  useEffect(() => {
    const el = messageRef.current;
    if (el) {
      setIsOverflowing(el.scrollHeight > el.clientHeight + 1);
    }
  }, [recco.message]);

  return (
    <div className={`bg-[#F5F5F7] flex flex-1 flex-col my-2 rounded-lg ${recco.resources.length === 0 ? 'justify-center' : ''}`}>
      {recco.resources && recco.resources.length > 0 && (
        <Carousel
          className="w-full"
          emulateTouch
          key={recco.id}
          showIndicators={false}
          showStatus={false}
          showThumbs={false}
          swipeable
          useKeyboardArrows
          onChange={index => {
            videoRefs.current.forEach((video, i) => {
              if (video) {
                if (i === index) {
                  video.play().catch(() => {});
                } else {
                  video.pause();
                }
              }
            });
          }}>
          {recco?.resources.map((item, index) => (
            <div key={index} className="bg-black overflow-hidden pb-[100%] relative rounded-lg w-full">
              {item.type === 'video' ? (
                <video
                  className="absolute h-full left-0 object-contain top-0 w-full"
                  ref={el => (videoRefs.current[index] = el)}
                  src={item.url}
                  autoPlay
                  controls
                  loop
                  muted
                  playsInline
                />
              ) : (
                <img src={item.url} alt="Media" className="absolute h-full left-0 object-contain top-0 w-full" />
              )}
            </div>
          ))}
        </Carousel>
      )}
      <div className={`flex flex-col items-center pt-3 px-3 text-center ${recco.resources.length === 0 ? 'flex-1 justify-center' : ''}`}>
        <div className={`text-[#1A1A1A] ${recco.resources.length === 0 ? 'font-medium text-base' : 'text-sm'}`}>
          <div
            ref={messageRef}
            className={`duration-200 ease-in-out relative transition-all ${
              isExpanded ? '' : recco.resources.length === 0 ? 'line-clamp-5' : 'line-clamp-2'
            }`}>
            {recco.message}
            {!isExpanded && isOverflowing && (
              <span
                className="cursor-pointer text-blue-500"
                onClick={toggleDescription}
                style={{
                  position: 'absolute',
                  bottom: '0',
                  right: '0',
                  backgroundColor: '#F5F5F7',
                  paddingLeft: '4px',
                }}>
                ...read more
              </span>
            )}
          </div>
        </div>
        <div className="flex gap-2 items-center justify-center mt-2 p-2">
          <RoundedProfilePicture url={recco.createdBy?.profilePictureResource?.url} name={recco.createdBy?.displayName} size={24} />
          <p className="font-medium text-xs text-[#2B2B2B]">{recco.createdBy?.displayName}</p>
        </div>
      </div>
      <div className="p-2">
        <div className="flex flex-wrap gap-2 mb-2">
          {recco.cred?.skills &&
            recco.cred.skills.map((skill, index) => (
              <div key={index} className="bg-[#f2e3ff] justify-center min-h-8 px-4 py-1 rounded-full">
                <span className="font-medium text-xs text-[#1A1A1A]">{skill.skill.name}</span>
              </div>
            ))}
        </div>
        <div className="flex flex-wrap gap-2 mt-2">
          {recco.cred?.organizations &&
            recco.cred.organizations.map((org, index) => (
              <button disabled key={index} onClick={() => {}} className="bg-[#1A1A1A] justify-center min-h-8 px-4 py-1 rounded-full">
                <span className="font-medium text-xs text-white">{org.organization.name}</span>
              </button>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ReccoCard;
